import React, { useState, useEffect } from "react";
import ConversationsList from "./ConversationsList";
import AIChat from "components/AIChat/AIChat";
import { apiCreateConversation, apiGetConversations } from "api/apiAgent";

const ConversationLayout = () => {
  const [conversations, setConversations] = useState([]);

  const [selectedConversationId, setSelectedConversationId] =
    useState("current");

  const handleSelectConversation = (conversationId) => {
    setSelectedConversationId(conversationId);
  };

  const handleNewConversation = async () => {
    try {
      const newConversation = await apiCreateConversation();
      setConversations((prev) => [newConversation, ...prev]);
      setSelectedConversationId(newConversation._id);
    } catch (error) {
      console.error("Error creating conversation:", error);
    }
  };

  const updateConversationTitle = (conversationId, title) => {
    setConversations((prev) =>
      prev.map((conv) =>
        conv._id === conversationId
          ? { ...conv, title: title.slice(0, 50) }
          : conv
      )
    );
  };

  const updateLastMessageTime = (conversationId, tokenUsage) => {
    fetchConversations();
  };

  const fetchConversations = async () => {
    try {
      const conversations = await apiGetConversations();
      setConversations(conversations);
      setSelectedConversationId(conversations[0]._id);
    } catch (error) {
      console.error("Error fetching conversations:", error);
    }
  };

  const selectedConversation = conversations.find(
    (conv) => conv._id === selectedConversationId
  );

  useEffect(() => {
    document.title = "Agent | Dindicator Dashboard";
    fetchConversations();
  }, []);

  return (
    <div className="flex overflow-hidden">
      {/* Mobile overlay for sidebar */}
      {/* <div className="md:hidden fixed inset-0 z-40 pointer-events-none">
        <ConversationsList
          conversations={conversations}
          selectedConversationId={selectedConversationId}
          onSelectConversation={handleSelectConversation}
          onNewConversation={handleNewConversation}
        />
      </div> */}

      {/* Desktop sidebar */}
      <div className="hidden md:flex">
        <ConversationsList
          conversations={conversations}
          selectedConversationId={selectedConversationId}
          onSelectConversation={handleSelectConversation}
          onNewConversation={handleNewConversation}
        />
      </div>

      <div className="flex-1 min-h-0 ps-6 md:ps-4 lg:ps-6">
        {selectedConversation && (
          <AIChat
            selectedConversation={selectedConversation}
            onTitleUpdate={updateConversationTitle}
            updateLastMessageTime={updateLastMessageTime}
            fetchConversations={fetchConversations}
          />
        )}
      </div>
    </div>
  );
};

export default ConversationLayout;
